export const categories = [
  {
    id: 'entertainment',
    name: '娱乐',
    slug: 'entertainment',
    icon: 'ri-movie-2-line',
    description: '影视音乐、游戏电竞、综艺节目等泛娱乐内容',
    image: 'https://readdy.ai/api/search-image?query=Modern%20entertainment%20studio%20with%20colorful%20stage%20lighting%2C%20warm%20atmosphere%2C%20cinematic%20movie%20posters%20and%20gaming%20consoles%20displayed%20artistically%2C%20soft%20ambient%20light%2C%20minimalist%20composition&width=800&height=600&seq=cat-entertainment&orientation=landscape',
  },
  {
    id: 'news',
    name: '资讯',
    slug: 'news',
    icon: 'ri-newspaper-line',
    description: '亚洲热点新闻、财经动态、科技前沿资讯',
    image: 'https://readdy.ai/api/search-image?query=Modern%20digital%20newsroom%20with%20multiple%20screens%20displaying%20breaking%20news%2C%20warm%20lighting%2C%20clean%20minimalist%20desk%20setup%2C%20professional%20atmosphere%2C%20soft%20natural%20light%20from%20window&width=800&height=600&seq=cat-news&orientation=landscape',
  },
  {
    id: 'shopping',
    name: '购物',
    slug: 'shopping',
    icon: 'ri-shopping-bag-3-line',
    description: '精选好物推荐、优惠折扣、购物攻略指南',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20online%20shopping%20display%20with%20premium%20lifestyle%20products%20arranged%20on%20minimalist%20shelves%2C%20warm%20neutral%20tones%2C%20soft%20studio%20lighting%2C%20clean%20composition%2C%20modern%20retail%20aesthetic&width=800&height=600&seq=cat-shopping&orientation=landscape',
  },
  {
    id: 'social',
    name: '社交',
    slug: 'social',
    icon: 'ri-group-line',
    description: '社区互动、话题讨论、兴趣圈层交流平台',
    image: 'https://readdy.ai/api/search-image?query=Diverse%20group%20of%20people%20connecting%20through%20digital%20devices%20in%20warm%20modern%20coworking%20space%2C%20soft%20natural%20light%2C%20friendly%20atmosphere%2C%20minimalist%20interior%2C%20creative%20composition&width=800&height=600&seq=cat-social&orientation=landscape',
  },
  {
    id: 'tech',
    name: '科技',
    slug: 'tech',
    icon: 'ri-cpu-line',
    description: 'AI人工智能、数码产品、互联网创新技术',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20technology%20lab%20with%20holographic%20displays%20and%20circuit%20boards%2C%20warm%20ambient%20lighting%20with%20subtle%20neon%20accents%2C%20minimalist%20design%2C%20clean%20modern%20aesthetic&width=800&height=600&seq=cat-tech&orientation=landscape',
  },
  {
    id: 'lifestyle',
    name: '生活',
    slug: 'lifestyle',
    icon: 'ri-heart-pulse-line',
    description: '健康养生、美食旅游、家居生活品质指南',
    image: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20modern%20lifestyle%20scene%20with%20healthy%20food%20and%20travel%20accessories%20on%20wooden%20table%2C%20soft%20natural%20window%20light%2C%20minimalist%20Scandinavian%20interior%2C%20peaceful%20atmosphere&width=800&height=600&seq=cat-lifestyle&orientation=landscape',
  },
];

export const featuredArticles = [
  {
    id: 'article-1',
    title: '2026年亚洲数字经济发展趋势：AI驱动的全新时代',
    excerpt: '随着人工智能技术的飞速发展，亚洲各国纷纷加速数字化转型。从新加坡智慧国家到中国数字经济的蓬勃发展，亚洲正在成为全球数字创新的核心引擎。本文将深入分析2026年亚洲数字经济的最新趋势...',
    category: '科技',
    categorySlug: 'tech',
    author: '张明远',
    date: '2026-08-10',
    readTime: '8分钟',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20Asian%20cityscape%20with%20digital%20data%20flows%20and%20AI%20visualizations%2C%20warm%20golden%20sunset%20light%2C%20modern%20skyscrapers%2C%20clean%20minimalist%20aesthetic%2C%20professional%20editorial%20style&width=1200&height=800&seq=article-digital-economy&orientation=landscape',
    featured: true,
  },
  {
    id: 'article-2',
    title: '亚洲流媒体大战：2026年各大平台内容策略解析',
    excerpt: 'Netflix、Disney+、爱奇艺、Viu等流媒体平台在亚洲市场的竞争日趋白热化。本土化内容策略成为制胜关键，韩剧、日漫、华语剧集的投资规模不断刷新纪录...',
    category: '娱乐',
    categorySlug: 'entertainment',
    author: '李思雨',
    date: '2026-08-09',
    readTime: '6分钟',
    image: 'https://readdy.ai/api/search-image?query=Modern%20home%20entertainment%20setup%20with%20large%20screen%20displaying%20colorful%20streaming%20interface%2C%20warm%20cozy%20living%20room%2C%20soft%20ambient%20lighting%2C%20minimalist%20decor%2C%20cinematic%20atmosphere&width=1200&height=800&seq=article-streaming&orientation=landscape',
    featured: true,
  },
  {
    id: 'article-3',
    title: '跨境电商新蓝海：东南亚市场2026年掘金指南',
    excerpt: 'Shopee、Lazada、TikTok Shop三大平台在东南亚持续扩张。RCEP协议红利下，中国品牌出海东南亚迎来了前所未有的机遇。本文为卖家提供2026年最全面的东南亚电商市场分析...',
    category: '购物',
    categorySlug: 'shopping',
    author: '王浩然',
    date: '2026-08-08',
    readTime: '10分钟',
    image: 'https://readdy.ai/api/search-image?query=Modern%20ecommerce%20logistics%20warehouse%20with%20packages%20and%20digital%20screens%20showing%20shipping%20routes%20across%20Southeast%20Asia%2C%20warm%20industrial%20lighting%2C%20clean%20organized%20space&width=1200&height=800&seq=article-ecommerce&orientation=landscape',
    featured: true,
  },
  {
    id: 'article-4',
    title: 'Web3社交网络崛起：去中心化如何改变亚洲社交格局',
    excerpt: 'Lens Protocol、Farcaster等去中心化社交协议正在亚洲获得大量用户。从内容创作经济到用户数据主权，Web3社交网络为亚洲用户带来了全新的数字社交体验...',
    category: '社交',
    categorySlug: 'social',
    author: '陈雅婷',
    date: '2026-08-07',
    readTime: '7分钟',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20decentralized%20network%20visualization%20with%20connected%20nodes%20and%20warm%20glowing%20links%2C%20modern%20digital%20art%20style%2C%20clean%20minimalist%20composition%2C%20soft%20gradient%20background&width=1200&height=800&seq=article-web3&orientation=landscape',
    featured: false,
  },
  {
    id: 'article-5',
    title: '亚洲健康科技爆发：2026年最值得关注的医疗创新',
    excerpt: '从AI辅助诊断到远程医疗平台，亚洲健康科技领域正经历前所未有的创新浪潮。新加坡、日本、韩国和中国的初创企业在这个领域表现尤为突出...',
    category: '生活',
    categorySlug: 'lifestyle',
    author: '林小雨',
    date: '2026-08-06',
    readTime: '5分钟',
    image: 'https://readdy.ai/api/search-image?query=Modern%20medical%20technology%20lab%20with%20digital%20health%20monitoring%20devices%20and%20holographic%20displays%2C%20warm%20clean%20lighting%2C%20minimalist%20white%20interior%2C%20professional%20atmosphere&width=1200&height=800&seq=article-healthtech&orientation=landscape',
    featured: false,
  },
  {
    id: 'article-6',
    title: '亚洲移动游戏市场报告：超休闲游戏仍占主导',
    excerpt: '2026年上半年亚洲移动游戏市场规模突破800亿美元。超休闲游戏凭借低门槛、高留存的特点持续吸引大量用户，而中重度游戏则在ARPU值上保持领先...',
    category: '娱乐',
    categorySlug: 'entertainment',
    author: '赵子龙',
    date: '2026-08-05',
    readTime: '6分钟',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20mobile%20gaming%20setup%20with%20smartphone%20displaying%20casual%20game%2C%20warm%20ambient%20lighting%2C%20minimalist%20desk%20with%20gaming%20accessories%2C%20modern%20aesthetic&width=1200&height=800&seq=article-gaming&orientation=landscape',
    featured: false,
  },
];

export const latestArticles = [
  {
    id: 'article-7',
    title: '新加坡智慧城市建设经验：亚洲城市的数字化范本',
    category: '科技',
    categorySlug: 'tech',
    date: '2026-08-11',
    readTime: '7分钟',
    image: 'https://readdy.ai/api/search-image?query=Modern%20Singapore%20skyline%20with%20Marina%20Bay%20Sands%20and%20futuristic%20Supertree%20Grove%2C%20warm%20golden%20hour%20light%2C%20clean%20architectural%20photography%2C%20smart%20city%20concept&width=600&height=400&seq=article-singapore&orientation=landscape',
  },
  {
    id: 'article-8',
    title: '日本动漫产业数字化转型：AI动画制作新时代',
    category: '娱乐',
    categorySlug: 'entertainment',
    date: '2026-08-11',
    readTime: '5分钟',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20production%20studio%20with%20digital%20drawing%20tablets%20and%20colorful%20character%20designs%20on%20screens%2C%20warm%20creative%20workspace%2C%20soft%20lighting%2C%20artistic%20atmosphere&width=600&height=400&seq=article-anime&orientation=landscape',
  },
  {
    id: 'article-9',
    title: '印度电商Flipkart和Meesho崛起：下一个十亿用户市场',
    category: '购物',
    categorySlug: 'shopping',
    date: '2026-08-10',
    readTime: '8分钟',
    image: 'https://readdy.ai/api/search-image?query=Modern%20Indian%20ecommerce%20fulfillment%20center%20with%20packages%20and%20workers%2C%20warm%20lighting%2C%20organized%20industrial%20space%2C%20colorful%20branding%20elements&width=600&height=400&seq=article-india-ecom&orientation=landscape',
  },
  {
    id: 'article-10',
    title: '韩国社交媒体新趋势：KakaoTalk和Zepeto的元宇宙布局',
    category: '社交',
    categorySlug: 'social',
    date: '2026-08-09',
    readTime: '6分钟',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20Korean%20digital%20avatar%20interface%20on%20smartphone%20screen%2C%20warm%20cafe%20setting%2C%20modern%20minimalist%20aesthetic%2C%20soft%20natural%20light%20through%20window&width=600&height=400&seq=article-korea-social&orientation=landscape',
  },
];

export const services = [
  {
    id: 'service-1',
    title: '娱乐平台',
    description: '海量影视、音乐、游戏内容，覆盖亚洲各地区语言和文化偏好，支持多设备同步观看。',
    icon: 'ri-live-line',
  },
  {
    id: 'service-2',
    title: '资讯服务',
    description: '7x24小时亚洲要闻追踪，汇聚各国主流媒体精华，AI智能推荐个性化资讯流。',
    icon: 'ri-global-line',
  },
  {
    id: 'service-3',
    title: '在线购物',
    description: '整合亚洲主流电商平台，提供独家折扣和比价工具，让跨境购物更简单实惠。',
    icon: 'ri-shopping-cart-2-line',
  },
  {
    id: 'service-4',
    title: '社交互动',
    description: '兴趣驱动的社区平台，连接志同道合的亚洲用户，分享生活与创意内容。',
    icon: 'ri-chat-smile-2-line',
  },
  {
    id: 'service-5',
    title: '会员特权',
    description: '尊享会员专属折扣、优先体验新功能、一对一客服支持，提升您的数字生活品质。',
    icon: 'ri-vip-crown-line',
  },
  {
    id: 'service-6',
    title: '安全保障',
    description: '银行级数据加密、实名认证体系、隐私保护机制，让您的数字生活安全无忧。',
    icon: 'ri-shield-check-line',
  },
];

export const memberBenefits = [
  {
    id: 'benefit-1',
    title: '专属折扣',
    description: '会员专享合作商家最低7折优惠，覆盖购物、餐饮、出行等场景',
    icon: 'ri-discount-percent-line',
  },
  {
    id: 'benefit-2',
    title: '抢先体验',
    description: '新功能、新服务优先体验权，参与产品内测和反馈',
    icon: 'ri-rocket-2-line',
  },
  {
    id: 'benefit-3',
    title: 'VIP客服',
    description: '7x24小时专属客服通道，平均响应时间不超过30秒',
    icon: 'ri-customer-service-2-line',
  },
  {
    id: 'benefit-4',
    title: '内容无广告',
    description: '会员专享无广告浏览体验，纯净的资讯阅读环境',
    icon: 'ri-advertisement-line',
  },
];

export const stats = [
  { number: '5000万+', label: '注册用户' },
  { number: '12个', label: '覆盖国家和地区' },
  { number: '8种', label: '支持语言' },
  { number: '99.9%', label: '服务可用率' },
];

export const faqData = [
  {
    question: '亚洲在线是什么？',
    answer: '亚洲在线是专为亚洲用户打造的综合数字服务平台，涵盖娱乐、资讯、购物、社交等多元场景。我们致力于为亚洲各地区用户提供流畅、安全、本地化的在线体验。',
  },
  {
    question: '亚洲在线覆盖哪些国家和地区？',
    answer: '目前亚洲在线已覆盖中国、日本、韩国、新加坡、马来西亚、泰国、印度尼西亚、越南、菲律宾、印度、沙特阿拉伯、阿联酋等12个亚洲主要国家和地区，并持续扩展中。',
  },
  {
    question: '如何成为亚洲在线会员？',
    answer: '您可以通过网站右上角的「加入会员」按钮注册账号。注册完全免费，升级高级会员可享受更多专属权益，包括专属折扣、无广告体验和VIP客服支持。',
  },
  {
    question: '亚洲在线支持哪些支付方式？',
    answer: '我们支持多种本地化支付方式，包括信用卡（Visa/Mastercard/JCB/银联）、支付宝、微信支付、PayNow、Touch \'n Go、GrabPay、Paytm等亚洲主流支付渠道。',
  },
  {
    question: '如何联系亚洲在线客服？',
    answer: '您可以通过「关于我们」页面的在线表单联系我们，或发送邮件至 support@taokep.cn。会员用户享有7x24小时VIP专属客服通道。',
  },
];